import { useState, useCallback, useEffect, useRef } from "react"
import { Global } from "../classes/global"
import { Player } from "../classes/player"

function CircularDial({ toggleReset }: { toggleReset: boolean }) {
	const [degree, setDegree] = useState(Global.dialValue)
	const previousReset = useRef<boolean>(true)
	const dialRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		if (toggleReset !== previousReset.current) {
			setDegree(0)
			previousReset.current = toggleReset
		}
		Global.dialValue = degree
		Player.rotateFabric(degree)
	}, [degree, toggleReset])

	function dialValueChange(value: number) {
		setDegree(value)
	}

	// Exposing the function globally for demonstration; replace with your preferred way of making it accessible externally
	Global.spatialDialValueChange = dialValueChange

	const updateValue = useCallback((clientX: number, clientY: number) => {
		if (dialRef.current) {
			const { left, top, width, height } =
				dialRef.current.getBoundingClientRect()
			const dialCenterX = left + width / 2
			const dialCenterY = top + height / 2
			const radians = Math.atan2(clientY - dialCenterY, clientX - dialCenterX)
			let newDegree = radians * (180 / Math.PI) + 90
			if (newDegree < 0) newDegree += 360
			setDegree(Math.round(newDegree))
		}
	}, [])

	const handleInteractionStart = useCallback(() => {
		const moveHandler = (e: MouseEvent | TouchEvent) => {
			e.preventDefault() // Prevent scrolling on touch devices
			let clientX, clientY
			if ("touches" in e) {
				clientX = e.touches[0].clientX
				clientY = e.touches[0].clientY
			} else {
				clientX = e.clientX
				clientY = e.clientY
			}
			updateValue(clientX, clientY)
		}

		const endHandler = () => {
			document.removeEventListener("mousemove", moveHandler)
			document.removeEventListener("mouseup", endHandler)
			document.removeEventListener("touchmove", moveHandler)
			document.removeEventListener("touchend", endHandler)
		}

		document.addEventListener("mousemove", moveHandler)
		document.addEventListener("mouseup", endHandler)
		document.addEventListener("touchmove", moveHandler)
		document.addEventListener("touchend", endHandler)
	}, [updateValue])

	return (
		<div className="dial-container">
			<div
				className="dial"
				ref={dialRef}
				onMouseDown={handleInteractionStart}
				onTouchStart={handleInteractionStart}
				style={{ transform: `rotate(${degree}deg)` }}
			>
				<div className="needle"></div>
			</div>
		</div>
	)
}

export function Angle() {
	const [angleReset, setAngleReset] = useState(true)

	function angleChecked() {
		if (Global.showFabric) {
			Global.showFabric = false
			setAngleReset(!angleReset)
		}
	}

	return (
		<div className="tab">
			<input type="radio" name="accordion-2" onChange={angleChecked} id="rd2" />
			<label htmlFor="rd2" className="tab__label">
				Angle
			</label>
			<div className="tab__content">
				<p id="angleText">
					Drag the circle to the angle position desired for your fabric texture
				</p>
				<CircularDial toggleReset={angleReset} />
			</div>
		</div>
	)
}
